export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const CLEAR_AUTH_STATE = "CLEAR_AUTH_STATE";
export const LOGOUT_USER = "LOGOUT_USER";
